import { Controller } from '@hotwired/stimulus';

export default class FormSubmitController extends Controller {
  submit() {
    this.element.submit();
  }
}
